import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Banner for the shared /expense-lines message; "Review heads" link is Super Admin only.
export const ExpenseLinesNotice = ({ lines, testId }) => {
  const { user } = useAuth();
  if (!lines?.message) return null;
  const isAdmin = user?.role === "Admin";
  const text = lines.review_needed && isAdmin ? lines.message.replace(/ → Review heads\.$/, " → ") : lines.message;
  return (
    <div className="mt-2 rounded border border-amber-300 bg-amber-50 text-xs text-amber-900 p-2" data-testid={testId}>
      {text}
      {lines.review_needed && isAdmin && (
        <Link to={lines.review_url} className="font-semibold underline text-blue-700" data-testid={`${testId}-review-link`}>Review heads</Link>
      )}
      {lines.review_needed && isAdmin && "."}
    </div>
  );
};
